import { render, staticRenderFns } from "./BaseServiceSystem.vue?vue&type=template&id=67840abe"
import script from "./BaseServiceSystem.vue?vue&type=script&lang=js"
export * from "./BaseServiceSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports